import type { PillConfig } from '#types/config/components/vf/pill'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    container: 'b b-grey-80 rounded-full bg-transparent c-grey-20 hocus:bg-grey-70'
  },
  removeIcon: 'close'
} satisfies RecursivePartial<PillConfig>
